import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValueListsService } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { of } from 'rxjs';

@Component({
  selector: 'sp-chips-listbox-option',
  templateUrl: './chips-listbox-option.component.html',
  styleUrls: ['./chips-listbox-option.component.scss'],
})
export class ChipsListboxOptionComponent {
  /** Chip data source */
  @Input() dataSource!: AnyType;
  /** Enable to show user avatar */
  @Input() showAvatar?: boolean = false;
  /** Selectable mark the chips */
  @Input() chipViewMode: 'view' | 'edit' = 'edit';
  /** Override chip view mode classes */
  @Input() chipViewModeClasses: string[] = [];
  /** Enable clear all chip */
  @Input() clearAllChip = false;
  /** Enable highlighted */
  @Input() highlighted = true;
  /** Enable selectable */
  @Input() selectable = true;
  /** emit when a single chip is removed */
  @Output() removeChip = new EventEmitter<AnyType>();
  /** emit when all chip is removed */
  @Output() removeChips = new EventEmitter<AnyType>();
  /** emit selected chip */
  @Output() selectedChips = new EventEmitter<AnyType>();

  dataSourceStringType!: boolean;
  dataSourceObjType!: boolean;

  constructor(protected valueListsService: ValueListsService) {}

  /**
   * Display chip value on template
   * @param list
   * @returns
   */
  displayList(list: AnyType) {
    if (this.showAvatar || (list && list.name)) {
      return this.valueListsService.lookupUserName(list);
    } else {
      return of(list);
    }
  }

  /**
   * Remove chip
   * @param list
   */
  remove(list: AnyType) {
    this.removeChip.emit(list);
  }

  /**
   * Check value for type string
   * @param val
   * @returns
   */
  isString(val: string): boolean {
    return typeof val === 'string';
  }

  clearAll() {
    this.removeChips.emit();
  }
}
